import sanitizeHtml from 'sanitize-html';
import parse from 'html-react-parser';
import { cloneElement } from 'react';
import { contactLog } from './Accesslog';
import { linkContactText } from './ContactLinks';
import './ContactLinks.css';
import 'quill/dist/quill.snow.css'; 

// 允许的标签
const allowedTags = ['p', 'strong', 'em', 'u', 'span', 'br', 'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'a'];

// 允许的属性
const allowedAttributes = {
  a: ['href', 'target', 'rel', 'class'],
  span: ['style', 'class'],
  p: ['class'],
  strong: ['class'],
  em: ['class'],
  u: ['class'],
  h1: ['class'],
  h2: ['class'],
  h3: ['class'],
  h4: ['class'],
  ul: ['class'],
  ol: ['class'],
  li: ['class'],
};

// 清理并解析 HTML 内容为 React 元素
export const sanitizeAndParseHtml = (htmlString, venueId) => {
  if (typeof htmlString !== 'string') {
    console.warn("Expected string but received:", typeof htmlString);
    return htmlString || null;
  }

  // 清理 HTML，移除不安全内容，不解析 style 属性
  const cleanedHtml = sanitizeHtml(htmlString, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttributes,
    disallowedTagsMode: 'discard',
    parseStyleAttributes: false, // 关闭对 style 属性的解析
    allowedSchemes: ['http', 'https', 'mailto', 'tel'],
    allowProtocolRelative: false,
    transformTags: {
      a: (tagName, attrs) => ({ tagName, attribs: {
        href: attrs.href || '', class: 'dc-contact-link',
        ...(attrs.target === '_blank' ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
      } }),
    },
  });

  // console.log('Original HTML:', htmlString);
  // console.log('Cleaned HTML:', cleanedHtml);

  // 使用 html-react-parser 解析并手动处理样式中的 color
  return parse(linkContactText(cleanedHtml), {
    transform: (element, node) => {
      if (!venueId || node.name !== 'a') return element;
      const href = node.attribs.href || '';
      const type = /^\s*tel:/i.test(href) ? 'Phone' : /^\s*mailto:/i.test(href) ? 'Email' : null;
      if (!type) return element;
      // Keep native link navigation immediate while the unload-safe log is sent.
      return cloneElement(element, {
        onClick: event => {
          if (!event.defaultPrevented) contactLog(venueId, type);
        },
      });
    },
  });
};
